import * as z from 'zod'
import { logger } from '~/shared/lib/logger'
import { dateSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const attributesSchema = z.object({
  amount: z.number(),
  balanceType: z.string().optional(),
})
const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributesSchema)

export type BalanceAttributes = z.infer<typeof attributesSchema>

export class Balance extends ApiModel<typeof schema, BalanceAttributes> {
  static jsonApiType = 'balances'

  static schema = schema

  getAmount(): number {
    return this.getAttribute('amount')
  }

  getBalanceType(): string | undefined {
    return this.getAttribute('balanceType')
  }

  static async my() {
    const url = `${Balance.getJsonApiUrl()}/my`
    const response = await Balance.effectiveHttpClient.get(url)
    const data = response?.getData().data
    return new Balance(data.attributes, data.id)
  }

  static async myAll(): Promise<Balance[]> {
    try {
      const url = `${Balance.getJsonApiUrl()}/my-all`
      const response = await Balance.effectiveHttpClient.get(url)
      const items: { id: string; attributes: BalanceAttributes }[] =
        response?.getData()?.data ?? []
      return items.map((item) => new Balance(item.attributes, item.id))
    } catch (e) {
      logger.error(e)
      return []
    }
  }
}
